var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"all"},[(_vm.offer)?_c('Offer',{attrs:{"isVta":_vm.isVtaSL,"data":_vm.offer,"onSubmit":_vm.submit,"placement":_vm.placement}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }